import { useEffect, useRef } from "react"
import { isTokenValid } from "@/helpers/jwt"
import { useAppDispatch, useAppSelector } from "@/store"
import { useAuthMutation } from "@/store/apis/authAPI/auth.api"
import { setReAuthState } from "@/store/slices/app"
import { PlayerSelectors } from "@/store/slices/player"

export const useAutoAuth = () => {
  const dispatch = useAppDispatch()

  const isTMA = useAppSelector((state) => state.app.isTMA)
  const reAuthState = useAppSelector((state) => state.app.reAuthState)
  const isAuthorized = useAppSelector(PlayerSelectors.selectIsAuthorized())

  const isReAuthingRef = useRef(false)

  const [auth] = useAuthMutation()

  // On mount: if TMA user has no valid tokens — trigger auth flow
  useEffect(() => {
    if (!isTMA || isAuthorized || reAuthState === "loading") return
    if (isTokenValid("accessToken") || isTokenValid("refreshToken")) return
    dispatch(setReAuthState("loading"))
  }, [isTMA, isAuthorized, reAuthState])

  // Execute TMA auth when reAuthState === 'loading'
  useEffect(() => {
    if (reAuthState !== "loading" || isReAuthingRef.current) return
    if (!isTMA) {
      dispatch(setReAuthState("error"))
      return
    }
    isReAuthingRef.current = true
    auth()
      .unwrap()
      .then(() => dispatch(setReAuthState("idle")))
      .catch(() => dispatch(setReAuthState("error")))
      .finally(() => {
        isReAuthingRef.current = false
      })
  }, [reAuthState])
}
